import { Layout, Spin, Table, Modal } from "antd";
const { Content } = Layout;

import React, { Component } from "react";
import gatewayService from "../GatewayCountryLogs/services";
import service from "./service";
import getColumn from "./column";
import FilterForm from "./form";
import PaymentDetail from "../Payment/payment-detail.modal";

class PaymentLogModal extends Component {
  state = {
    loading: true,
    dataSource: [],
    adminList: [],
    member: null,
    defaultSearch: null,

    //payment_detail
    kycAdminReasonList: [],
    visibleDetailModal: false,
    currentPaymentData: {},
  };

  currentPage = 1;
  currentSearch = "";
  limit = 10;
  totalRows = 0;

  async componentDidMount() {
    const { data } = this.props;
    const adminList = await gatewayService.getAdminLists();
    const defaultSearch = { member_id: data.memberId };
    this.currentSearch = JSON.stringify(defaultSearch);
    const { totalRows, dataSource } = await service.getPaymentLogList(
      this.currentPage,
      this.limit,
      this.currentSearch
    );

    this.totalRows = totalRows;

    this.setState({
      loading: false,
      dataSource,
      adminList: adminList.list,
      member: data,
      defaultSearch,
    });
  }

  afterFormSubmit = (value) => {
    let tmp;
    if (value) {
      tmp = JSON.parse(value);
      tmp = { ...this.state.defaultSearch, ...tmp };

      if (tmp["admin_id"]) {
        tmp["admin_id"] = `${tmp["admin_id"]}`;
      }
    } else {
      tmp = this.state.defaultSearch;
    }

    this.currentSearch = JSON.stringify(tmp);
    this.changePage(this.currentPage, this.limit);
  };

  changePage = async (page, limit) => {
    this.setState({ loading: true });
    this.currentPage = page;
    this.limit = limit;

    const { dataSource, totalRows } = await service.getPaymentLogList(
      page,
      limit,
      this.currentSearch
    );

    if (totalRows > 0 && dataSource.length === 0) {
      this.changePage(1, this.limit);
      this.setState({ loading: false });
    }

    this.totalRows = totalRows;
    this.setState({
      dataSource,
      loading: false,
    });
  };

  onCloseDetailModal = () => {
    this.setState({
      visibleDetailModal: false,
    });
  };

  onClickDetail = async (paymentId, { kyc_logs_detail, product_package }) => {
    this.setState({
      loading: true,
    });
    let paymentDetail = await service.getPaymentDetail(paymentId);
    let reasonList = this.state.kycAdminReasonList;
    const hasFetechReason = reasonList.length > 0;
    if (!hasFetechReason) {
      reasonList = await service.getKYCAdminReason();
    }

    paymentDetail = {
      ...paymentDetail,
      kyc_logs_detail,
      product_package_id: product_package.ID,
      product_detail: product_package,
    };

    this.setState({
      loading: false,
      currentPaymentData: paymentDetail,
      kycAdminReasonList: reasonList,
      visibleDetailModal: true,
    });
  };

  render() {
    const propsTable = {
      className: "my-table",
      columns: getColumn(this.onClickDetail),
      dataSource: this.state.dataSource,
      rowKey: "id",
      pagination: {
        pageSize: this.limit,
        total: this.totalRows,
        current: this.currentPage,
        onChange: this.changePage,
        size: "small",
      },
      scroll: { x: "max-content" }
    };

    const { onCancel, visible } = this.props;
    let title =
      "Payment Log ของ " +
      (this.state.member ? this.state.member.memberName : "-");

    return (
      <Modal
        className="my-layout"
        visible={visible}
        maskClosable={false}
        onCancel={onCancel}
        title={title}
        width={1000}
        footer={null}
        style={{ top: 20 }}
      >
        <Layout className="my-layout">
          <Spin spinning={this.state.loading} tip="กำลังโหลดข้อมูล...">
            <FilterForm
              adminList={this.state.adminList}
              onSubmit={(v) => this.afterFormSubmit(v)}
            />
            <Content
              style={{
                background: "#fff",
                padding: 24,
                margin: "16px 0",
                minHeight: 300,
              }}
            >
              <Table {...propsTable} />
            </Content>
          </Spin>
          <PaymentDetail
            visibleDetailModal={this.state.visibleDetailModal}
            onCloseDetailModal={this.onCloseDetailModal}
            data={this.state.currentPaymentData}
            approved={null}
            kycAdminReasonList={this.state.kycAdminReasonList}
          />
        </Layout>
      </Modal>
    );
  }
}
export default PaymentLogModal;



// WEBPACK FOOTER //
// ./src/containers/PaymentLog/modal.js